import { render, staticRenderFns } from "./CaixaListaPedidos.vue?vue&type=template&id=c4d73252&scoped=true"
import script from "./CaixaListaPedidos.vue?vue&type=script&lang=js"
export * from "./CaixaListaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d73252",
  null
  
)

export default component.exports